import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJEventConstant from "../../../constant/FJEventConstant";
import { FJUndoAction } from "../../../redux/action/FJRoot.action";
import key from 'keymaster';
import FJUndo from "../view/FJUndo";
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJUtil from "../../../util/FJUtil";

class FJUndoContainer extends Component {

  componentDidMount() {
    let {updateUndoRedo, undo, redo} = this.props;
    (function (self) {
      key('ctrl+z, ⌘+z', 'default', (e) => {
        e.stopPropagation();
        e.preventDefault();
				FJCoreUtil.triggerBodyMousedown()
				self.ealogClick('hot key')
        undo();
      });
      key('shift+ctrl+z, shift+⌘+z, ctrl+y, shift+⌘+y', 'default', (e) => {
        e.stopPropagation();
        e.preventDefault();
				FJCoreUtil.triggerBodyMousedown()
				self.ealogClick('hot key')
        redo();
      });
      window.FJEvent.subscribe(FJEventConstant.CHANGE_UNDO_REDO_STATUS, updateUndoRedo);
    })(this);
  }

  ealogClick = (type) => {
		FJUtil.ealog('timeline_redo_undo_use', {
			type: type
		})
	}

  render() {
    let { undo, redo, hasUndo, hasRedo } = this.props;

    return (
      <FJUndo undo={undo}
              redo={redo}
              hasUndo={hasUndo}
              hasRedo={hasRedo}
							ealogClick={this.ealogClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hasRedo: state.undo.hasRedo,
    hasUndo: state.undo.hasUndo,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUndoRedo: function () {
      dispatch(FJUndoAction.updateUndoRedoAction());
    },
    undo: function () {
      dispatch(FJUndoAction.undoAction());
    },
    redo: function () {
      dispatch(FJUndoAction.redoAction());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJUndoContainer);
